/* unplugin-vue-components disabled */import { render } from "./tagView.vue?vue&type=template&id=3374e00a"
import script from "./tagView.vue?vue&type=script&lang=js"
export * from "./tagView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__